import store from "@/store";
import {
  Module,
  VuexModule,
  getModule,
  MutationAction,
} from "vuex-module-decorators";
import { QRScannerServiceApi } from "@/api";
import { IQRScannerState, TicketFormRequest, QrTicketScanRequest, TicketScanRequest } from "./types";

const initialState = Object.freeze<IQRScannerState>({
  //   eventID: "",
  //   ticketURL: "",
  success: false,
  error: "",
});

@Module({ dynamic: true, store, name: "QRScanner" })
class QRScanner extends VuexModule implements IQRScannerState {
  //   eventID: string = initialState.eventID;
  //   ticketURL: string = initialState.ticketURL;
  success: boolean = initialState.success;
  error: string = initialState.error;

  public get currentSuccessStatus(): boolean {
    return this.success;
  }

  public get currentErrorMessage(): string {
    return this.error;
  }

  @MutationAction
  public async ScanTicket(
    request: TicketScanRequest
  ): Promise<IQRScannerState> {
    const response = await QRScannerServiceApi.ScanTicket(request);

    return {
      success: response.success,
      error: response.error,
    };
  }

  @MutationAction
  public async ScanTicketQr(
    request: any
  ): Promise<IQRScannerState> {
    const response = await QRScannerServiceApi.ScanTicketQr(request);
    return {
      success: response.success,
      error: response.error,
    };
  }

  @MutationAction
  public async TicketForm(
    request: TicketFormRequest
  ): Promise<IQRScannerState> {
    const response = await QRScannerServiceApi.ScanTicketForm(request);
    // console.log(response)
    return {
      success: response.success,
      error: response.error,
    };
  }
}

export const QRScannerModule = getModule(QRScanner);
